<template>
  <div>
    <v-chip v-if="size === 'small'" class="pro-chip pa-3" color="accent" x-small>
      <p class="my-0 pro-badge-small label">PRO</p>
    </v-chip>
    <v-chip v-else-if="size === 'medium'" class="pro-chip" color="accent" small>
      <p class="my-0 pro-badge-small label">PRO</p>
    </v-chip>
  </div>
</template>

<script>
export default {
  name: "ProBadge",
  props: {
    size: String,
  }
}
</script>

<style>

.pro-chip {
  background-color: var(--v-accent-base) !important;
}
.pro-badge-small {
  font: 12px 'Avenir', sans-serif;
  color: #111111;
  font-weight: bold;
}

.pro-badge-medium {
  font: 14px 'Avenir', sans-serif;
  color: #111111;
  font-weight: bold;
}
</style>